module.exports = __webpack_public_path__ + "static/img/gy_2.18859aff.png";